import collectingSpaceship from '@/assets/images/collecting-spaceship.svg'
import noQuizImage from '@/assets/images/sofa-tv.svg'
import { theme } from '@/theme/theme'
import { Box, styled, Typography } from '@mui/material'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export const NoInteractions: FC = () => {
  const { t } = useTranslation()
  return (
    <StyledNoResultsContainer>
      <StyledNoScoreImage />
      <Typography fontSize={18}>{t('campaignDashboard.campaignQuizResults.noInteractions')}</Typography>
    </StyledNoResultsContainer>
  )
}

export const NoQuizAvailable: FC = () => {
  return (
    <StyledNoResultsContainer>
      <StyledNoQuizImage />
      <Typography fontSize={18}>
        <Trans i18nKey={'campaignDashboard.campaignQuizResults.noQuiz'} components={{ 1: <b /> }} />
      </Typography>
    </StyledNoResultsContainer>
  )
}

const StyledNoScoreImage = styled(Box)(() => ({
  backgroundImage: `url(${collectingSpaceship})`,
  backgroundSize: '190px',
  backgroundRepeat: 'no-repeat',
  width: '190px',
  height: '200px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
}))

const StyledNoQuizImage = styled(Box)(() => ({
  backgroundImage: `url(${noQuizImage})`,
  backgroundSize: '300px',
  backgroundRepeat: 'no-repeat',
  width: '300px',
  height: '170px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
}))

const StyledNoResultsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1),
  gap: theme.spacing(3),
}))
